"use strict";

var _context, _context2, _context3, _context4;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getDateLocale: true,
  getSelectedLanguageCode: true,
  convertLanguageCodeToRegionalCode: true
};
_Object$defineProperty(exports, "convertLanguageCodeToRegionalCode", {
  enumerable: true,
  get: function () {
    return _convertLanguageCodeToRegionalCode.convertLanguageCodeToRegionalCode;
  }
});
_Object$defineProperty(exports, "getDateLocale", {
  enumerable: true,
  get: function () {
    return _getDateLocale.getDateLocale;
  }
});
_Object$defineProperty(exports, "getSelectedLanguageCode", {
  enumerable: true,
  get: function () {
    return _getSelectedLanguageCode.getSelectedLanguageCode;
  }
});
var _i18n = require("./i18n");
_forEachInstanceProperty(_context = _Object$keys(_i18n)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _i18n[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _i18n[key];
    }
  });
});
var _translatedMarkdown = require("./translated-markdown");
_forEachInstanceProperty(_context2 = _Object$keys(_translatedMarkdown)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _translatedMarkdown[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translatedMarkdown[key];
    }
  });
});
var _types = require("./types");
_forEachInstanceProperty(_context3 = _Object$keys(_types)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _schemas = require("./schemas");
_forEachInstanceProperty(_context4 = _Object$keys(_schemas)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _schemas[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _schemas[key];
    }
  });
});
var _getDateLocale = require("./utils/get-date-locale");
var _getSelectedLanguageCode = require("./utils/get-selected-language-code");
var _convertLanguageCodeToRegionalCode = require("./utils/convert-language-code-to-regional-code");